export class Conferences {
  static AL = 'AL';
  static NL = 'NL';
}
